import AnnotationPatientDetails from './AnnotationPatientDetails';
import AnnotationPatientInfo from './AnnotationPatientInfo';

const AnnotationPatientProfile = () => {
  return (
    <div className="d-flex">
      <AnnotationPatientInfo />
      <AnnotationPatientDetails />
    </div>
  );
};

export default AnnotationPatientProfile;
